export interface SearchDialogData {
	title: string;
	fields: {
		label: string;
		name: string;
		type: 'text' | 'email';
	}[];
}

export enum SearchOption {
	AllUsers = 'all-users',
	SearchUsers = 'search-users',
	AllOrganizations = 'all-organizations',
	SearchOrganizations = 'search-organizations'
}

export type SearchField = 'emailId' | 'userId' | 'organizationId' | 'displayName';
